import { CompanyFactory } from "@/modules/factory/company/company.factory";
import { CompanyHeaderModel } from "@/modules/module/model/client/company-model";

class Service {
    private WORKSPACE_STORAGE_NAME = 'workspace';
    private _company: Array<CompanyHeaderModel> = [];

    /**
     * Retorna a lista de empresas que o usuário possui acesso
     */
    async userCompanies() {
      if(this._company.length == 0) {
        this._company = await CompanyFactory.find();
      }

      return this._company;
    }

    products() {
      const companies = this._company;
      const defaultCompany = this.defaultCompany(companies);
      if (!defaultCompany) {
        return companies[0];
      }
      return defaultCompany;
    }

    /**
     * Retorna a última empresa acessada ou a primeira empresa caso seja o primeiro acesso
     */
    defaultCompany(companies: Array<CompanyHeaderModel>) {
        const defaultCompanyId = this.workspaceCompany();

        // Pega a primeira empresa caso não tenha nenhum selecionada
        if (!defaultCompanyId && companies && companies.length) {
          this.changeCompany(companies[0].keyCompanyGv ? companies[0].keyCompanyGv : companies[0].cnpj);
          return companies[0];
        }

        let company = companies.find(company => company.keyCompanyGv === defaultCompanyId || company.cnpj === defaultCompanyId);
        
        if (company && defaultCompanyId === company.cnpj && company.keyCompanyGv !== null) {
            this.changeCompany(company.keyCompanyGv);
        }

        if (!company && companies?.length > 0) {
          company = companies[0];

          this.changeCompany(company.keyCompanyGv ? company.keyCompanyGv : company.cnpj);
        }

        return company;
    }

    /**
     * Atualiza a última empresa acessada no localstorage
     * @param company
     */
    changeCompany(keyCompanyGv: string) {
        localStorage.setItem(this.WORKSPACE_STORAGE_NAME, keyCompanyGv);
    }

    /**
     * Retorna a última empresa acessada
     */
    workspaceCompany() {
        return localStorage.getItem(this.WORKSPACE_STORAGE_NAME) || undefined;
    }

    async isMultiCompany(companies: Array<CompanyHeaderModel>) {
        return companies.length > 1;
    }

    clearWorkspaceCompany() {
        localStorage.removeItem(this.WORKSPACE_STORAGE_NAME);
    }
}

export const MultiCompanyService = new Service();
